import Api from '../cart_api'

export default {
  computed: {
    hotel_display_name() {
      return this.item.hotel_display_name
    },

    isContracted() {
      if(this.item.h4h_hotel_attributes.contracted === undefined) {
        return true
      } else {
        return false
      }
    },

    assignCheckIn(){
      if(this.isContracted == true) {
        return this.item.contract_check_in
      } else {
        return this.item.h4h_hotel_attributes.hotel_check_in_date
      }
    },

    assignCheckOut(){
      if(this.isContracted == true) {
        return this.item.contract_check_out
      } else {
        return this.item.h4h_hotel_attributes.hotel_check_out_date
      }
    },

    maxHotelQty() {
      return Math.min(this.item.hotel_inventory_on_site, this.item.quantity, 10)
    },

    maxPackageQty() {
      return Math.min(this.item.inventory_on_site, 10)
    },

    transportationFee() {
      return this.$t('cart.eventTransportation')
    },

    transportationText() {
      return this.$t('cart.eventTransportationText')
    }
  },

  data() {
    return {
      ers: null,
      updating: false
    }
  },

  methods: {
    createPackageHashForUpdate(newPackageQty) {
      let itemHash = { quantity: newPackageQty }

      if (this.item.room_quantity > newPackageQty) {
        // Room Qty cannot be larger than Package Qty
        // You must update Room Qty with Package Qty when this happens
        itemHash = Object.assign( {}, itemHash, { room_quantity: newPackageQty } )
        this.ers = this.$t('roomQtyError')
      }

      return itemHash
    },

    changeOrderItem(body) {
      Api.changeOrderItem(this.item.id, 'PUT', body).then(item => {
        if (item.errors) { this.ers = item.errors }
        this.updating = false
      })
    },

    deleteItem() {
      if (this.updating) { return }
      this.ers = null
      this.updating = true

      Api.changeOrderItem(this.item.id, 'DELETE', null).then(item => {
        if (item.errors) { this.ers = item.errors }

        this.updating = false
      })
    },

    updateHotel(newHotelQty) {
      if (this.updating) { return }
      this.ers = null
      this.updating = true

      let body = JSON.stringify({ order_item: { room_quantity: newHotelQty } })
      this.changeOrderItem(body)
    },

    updatePackage(newPackageQty) {
      if (this.updating) { return }
      this.ers = null
      this.updating = true
      let body = JSON.stringify({ order_item: this.createPackageHashForUpdate(newPackageQty) })

      this.changeOrderItem(body)
    }
  },

  props: ['item']
}
